<template>
	<div v-if="edit === false">
		<div
			style="
				display: flex;
				justify-content: space-between;
				align-items: center;
				font-size: 16px;
				padding: 12px 20px 0px;
			"
		>
			<div @click="closeDetail" style="color: #07111b">關閉</div>
			<div style="font-size: 18px; font-weight: bold">送餐地址</div>
			<div style="color: #07111b">套用</div>
		</div>
		<div style="border: 1px solid #d4d4d4; margin: 10px 0px"></div>
		<div>
			<cube-radio-group class="radioStyle" style="padding: 0px 10px">
				<div
					style="
						display: flex;
						justify-content: space-between;
						align-items: center;
						padding-right: 20px;
					"
				>
					<div>
						<cube-radio option="1" v-model="selectedAddress">
							<div style="font-size: 15px; margin-left: 18px">
								<div>公司</div>
								<div>台中市 西屯區 仁愛街 168號</div>
								<div>備註: 放在對面管理室</div>
							</div>
						</cube-radio>
					</div>
					<div style="font-size: 15px" @click="edit = true">編輯</div>
				</div>
				<div style="border: 1px solid #d4d4d4; margin: 10px 0px"></div>
				<div
					style="
						display: flex;
						justify-content: space-between;
						align-items: center;
						padding-right: 20px;
					"
				>
					<div>
						<cube-radio option="2" v-model="selectedAddress">
							<div style="font-size: 15px; margin-left: 18px">
								<div>家</div>
								<div>台中市 西區 忠誠街 168號</div>
								<div>備註: 無</div>
							</div>
						</cube-radio>
					</div>
					<div style="font-size: 15px" @click="edit = true">編輯</div>
				</div>
			</cube-radio-group>
			<div style="border: 1px solid #d4d4d4; margin: 10px 0px"></div>
			<div style="padding: 10px 55px; font-size: 16px" @click="edit = true">
				<span style="color: #07111b">+</span>
				<span style="margin-left: 10px">新地址</span>
			</div>
			<div style="border: 1px solid #d4d4d4; margin: 10px 0px"></div>
		</div>
	</div>
	<div v-else>
		<div
			style="
				display: flex;
				justify-content: space-between;
				align-items: center;
				font-size: 16px;
				padding: 12px 20px 0px;
			"
		>
			<div @click="edit = false" style="color: #07111b">返回</div>
			<div style="font-size: 18px; font-weight: bold">送餐地址</div>
			<div style="width: 20px"></div>
		</div>
		<div style="border: 1px solid #d4d4d4; margin: 10px 0px"></div>
		<div style="margin: 15px 10px; padding: 5px 10px">
			<div class="card">
				<span><i class="cubeic-location"></i></span>
				<span style="font-size: 18px; font-weight: bold">西區 忠誠街 58號</span>
			</div>
			<div
				style="
					display: flex;
					justify-content: space-between;
					align-items: center;
					margin: 15px 0px;
				"
			>
				<div style="margin-right: 10px">
					<cube-input
						class="inlineCard"
						v-model="floor"
						placeholder="樓層(非必填)"
					></cube-input>
				</div>
				<div>
					<cube-input
						class="inlineCard"
						v-model="company"
						placeholder="公司名稱(非必填)"
					></cube-input>
				</div>
			</div>
			<div style="margin: 10px 0px">
				<cube-textarea
					v-model="note"
					class="inlineCard"
					placeholder="請輸入給跑腿員的備註"
				></cube-textarea>
			</div>
			<div style="margin: 15px 0px">
				<div style="font-size: 18px; font-weight: bold; margin-bottom: 12px">
					標籤為
				</div>
				<cube-checker
					class="checkerStyle"
					v-model="checkerValue"
					:options="options"
				/>
			</div>
		</div>

		<div class="footer">
			<div class="btnConfirm" @click="edit = false">
				<div style="font-size: 17px; font-weight: bold">儲存並繼續</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions } from "vuex";

export default {
	data() {
		return {
			selectedAddress: "",
			edit: false,
			floor: "",
			company: "",
			note: "",
			checkerValue: [],
			options: [
				{
					value: 1,
					text: "家",
				},
				{
					value: 2,
					text: "工作",
				},
				{
					value: 3,
					text: "其他",
				},
			],
		};
	},
	methods: {
		...mapActions({
			setAddress: "setAddress",
		}),
		closeDetail() {
			this.setAddress(false);
		},
	},
};
</script>

<style scoped>
.radioStyle >>> .border-top-1px,
.border-right-1px,
.border-bottom-1px,
.border-left-1px {
	position: inherit !important;
}

.card {
	margin: 10px 0px;
	border: 1px solid darkgray;
	box-shadow: 0px 1px 8px rgb(8, 6, 6);
	padding: 15px;
	border-radius: 10px;
}

.inlineCard {
	font-size: 12px;
	line-height: 16px;
	color: #b0aeae;
	border: 2px solid #e1e1e1;
	border-radius: 6px;
}
.footer {
	position: fixed;
	bottom: 0;
	width: 100%;
	height: 80px;
	background-color: #ffffff;
	box-shadow: 0 4px 10px 5px darkgrey;
}
.btnConfirm {
	margin: 15px;
	display: flex;
	justify-content: center;
	background-color: #2c3b53;
	border-radius: 8px;
	color: white;
	align-items: center;
	padding: 13px 20px;
	box-shadow: 0px 1px 8px darkgrey;
}
.checkerStyle >>> .cube-checker-item {
	border: 1px solid darkgray;
	box-shadow: 0px 1px 8px rgb(8 6 6);
	border-radius: 15px;
	padding: 10px 35px;
	font-size: 16px;
	color: #2c3b53;
	margin-right: 0px;
	position: inherit;
}
.checkerStyle >>> .cube-checker-item_active {
	background-color: #2c3b53;
	color: white;
	border: none;
}
.checkerStyle {
	display: flex;
	justify-content: space-between;
	align-items: center;
}
</style>
